module.exports = __webpack_public_path__ + "img/2b43994.png";